import React, { useEffect, useState } from "react"
import {
  listActualitesContainer,
  listActualitesHeaderContainer,
  actualitesContainer,
  listActualitesTitle,
  actualitesDescription,
  toutesNosActusResponsiveOnly,
  editButtonTitle,
} from "./actualites.module.scss"
import { Title } from "./actualites-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import RenderActualites from "./RenderActualites/render-actualites"
import { useActualites } from "gatsby-theme-blank/src/components/Home/Actualites/actualites-query"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------Parent component---------------------------//

const ListActualites = () => {
  const data = useActualites()
  const [finalData, setFinalData] = useState([])

  useEffect(() => {
    setFinalData(getPublishedData(data.allNodeActualites.edges))
  }, [data])

  if (finalData.length === 0) {
    return null
  }
  return (
    <div className={listActualitesContainer}>
      <div className={listActualitesHeaderContainer}>
        <Title className={listActualitesTitle}>
          <EditButton
            addedClass={editButtonTitle}
            link={
              "/taxonomy/term/" +
              data.taxonomyTermZoneDefinie.drupal_internal__tid +
              "/edit"
            }
          />
          {data.taxonomyTermZoneDefinie?.field_label || "À la une"}
        </Title>
        <div>
          <TransitionFade className="btn" link="/actualites">
            Toutes nos actus
          </TransitionFade>
        </div>
      </div>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={actualitesDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={actualitesContainer}>
        <RenderActualites actualiteData={finalData.slice(0, 10)} />
      </div>
      <div className={toutesNosActusResponsiveOnly}>
        <TransitionFade className="btn" link="/actualites">
          Toutes nos actus
        </TransitionFade>
      </div>
    </div>
  )
}

//-----------------------Parent component---------------------------//

export default ListActualites
